import { post, get, patch, del, upload } from '../../utils/api'
import { AxiosResponse } from 'axios'
import { UpdateProfileType } from './types'

export const signIn = (
  code: string,
  redirect_uri: string
): Promise<AxiosResponse> => post('/sso/login', { code, redirect_uri })

export const signOut = (redirect_url: string): Promise<AxiosResponse> =>
  post('/sso/logout', {
    redirect_url,
  })

export const fetchCourseUserState = (id: string): Promise<AxiosResponse> =>
  get(`/courses/courses/${id}/user-state`)

export const fetchProfile = (): Promise<AxiosResponse> => get('/me')

export const fetchNewAchievements = (): Promise<AxiosResponse> =>
  get('/achievements/achievements', {
    'filter[userAchievement.received_at]': 'null',
    include: 'imageMedia,userAchievement',
    sort: '-user_achievement',
  })

export const markViewedAchievement = (id: string): Promise<AxiosResponse> =>
  post(`/achievements/achievements/${id}/repay`)

export const saveProfile = (
  data: UpdateProfileType
): Promise<AxiosResponse> => {
  return patch('/me/profile', data)
}

export const uploadPhoto = (photo: File): Promise<AxiosResponse> => {
  return upload('/me/profile/photo', { field: 'photo', item: photo })
}

export const removePhoto = (): Promise<AxiosResponse> => {
  return del('/me/profile/photo')
}

export const fetchReferralLink = (
  type: string,
  redirect_url: string,
  is_reversive: string,
  connection_type?: string
): Promise<AxiosResponse> => {
  return post('/me/profile/referral-link', {
    type,
    redirect_url,
    is_reversive,
    connection_type,
  })
}

export const sendEmailInvite = (
  code: string,
  description: string,
  email: string
): Promise<AxiosResponse> =>
  post('/sso/connection', {
    code,
    type: 'email',
    description,
    email: [email],
  })

export const uploadAchievementScreenshot = (
  achievementId: string,
  image: File
): Promise<AxiosResponse> => {
  return upload(
    `/achievements/achievements/user-achievement/${achievementId}/attachment`,
    {
      field: 'file',
      item: image,
    }
  )
}

export const setProfileTeacher = (): Promise<AxiosResponse> => {
  return post('/me/become-teacher')
}

export const setProfileStudent = (): Promise<AxiosResponse> => {
  return post('/me/become-student')
}

export const fetchCertificates = (): Promise<AxiosResponse> => {
  return get('/me/certificates')
}
